'use client'
import '@dynamic-labs/sdk-api-core';
import '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import 'react';
import '@dynamic-labs/wallet-book';
import '../../../utils/constants/colors.js';
import '../../../utils/constants/values.js';
import { LocalStorage } from '../../../shared/utils/classes/storage/localStorage.js';
import '../../../shared/utils/classes/storage/sessionStorage.js';
import '@dynamic-labs/utils';
import '../../../shared/consts/index.js';

const AUTH_USER = 'dynamic_authenticated_user';
const syncLegacyStorage = (store) => {
    const legacyUser = LocalStorage.getFromLS(AUTH_USER);
    if (Boolean(legacyUser) && !store.getState().user) {
        store.setState({ user: legacyUser });
        LocalStorage.removeFromLS(AUTH_USER);
    }
    return store;
};

export { syncLegacyStorage };
